import React from "react";
import { SVGAsset } from "res";
import { PromoInfoView } from "./components/views/PromoInfoView";
import { PromoLinkView } from "./components/views/PromoLinkView";
import "./styles.css";
/**
 * @function PromoView 
 * @param {React.Component} icon Pass an icon as a React component into the component.
 * @param {STRING} title Pass the text for the promo title.
 * @param {STRING} description Pass the text for promo description.
 * @param {STRING} text Pass the text for the link.
 * @returns {React.Component}
 * @example
 * <PromoView icon={<SVGAsset id="MagnifyingGlassIcon" className="magnifying-glass-icon"/>} title="Some title" description="Some description" text="Some text">
 */
export default function PromoView(props) {
  const icon = props.icon ?? <SVGAsset id="MagnifyingGlassIcon" className="magnifying-glass-icon"/>;
  const title = props.title ?? "[title]";
  const description = props.description ?? "[description]";
  const text = props.text ?? "[text]";

  return (
    <div className="promo-view">
      <div className="promo-container flex-container flex-horizontal align-center">
        <PromoInfoView icon={icon} title={title} description={description} />
        <PromoLinkView text={text} onClick={ props.onClick } dataPoint={ props.dataPoint } />
      </div>
    </div>

  )
}